import { useMemo, useState } from "react";

export const SINGLE_ISSUANCE_STEPS = [
  { label: "Who & Trip", description: "Issuer & quote" },
  { label: "Plan & Price", description: "Cover & coupon" },
  { label: "Travelers", description: "Details & issue" },
];

export const useWizardSteps = ({ quoteData, coverOption }) => {
  const [activeStep, setActiveStep] = useState(0);

  const canProceed = useMemo(
    () => [Boolean(quoteData), Boolean(coverOption), true],
    [quoteData, coverOption]
  );

  const nextStep = () =>
    setActiveStep((step) => Math.min(step + 1, SINGLE_ISSUANCE_STEPS.length - 1));
  const prevStep = () => setActiveStep((step) => Math.max(step - 1, 0));
  const goToStep = (step) => setActiveStep(step);

  return {
    activeStep,
    steps: SINGLE_ISSUANCE_STEPS,
    canProceed,
    nextStep,
    prevStep,
    goToStep,
  };
};
